
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.222 4.39a2.1 2.1 0 011.485-.615h19.499a2.1 2.1 0 012.1 2.1v3a.6.6 0 01-.6.6H3.207a.6.6 0 01-.6-.6v-3a2.1 2.1 0 01.615-1.485zm1.485.585a.9.9 0 00-.9.9v2.4h21.299v-2.4a.9.9 0 00-.9-.9H4.707zm-.093 5.933a.6.6 0 01.6.6v9.086a2.429 2.429 0 002.428 2.428h13.629a2.428 2.428 0 002.428-2.428v-9.086a.6.6 0 011.2 0v9.086a3.628 3.628 0 01-3.628 3.628H7.642a3.629 3.629 0 01-3.628-3.628v-9.086a.6.6 0 01.6-.6zm7.883 1.67a.6.6 0 000 1.2h3.487a.6.6 0 100-1.2h-3.487z","fill":"#343440"}})])
          )
        }
      }
    